<ng-container *ngIf="pill">
    <div class="btr-ib-status">
        <ng-container *ngIf="pill.isAction; else staticPill">
            <button class="btr-ib-status__pill" type="button" [attr.aria-label]="pill.ariaLabel" (click)="openPanel.emit()">
                <app-ds-badge size="sm" [theme]="pill.theme" [icon]="pill.icon" [label]="pill.label"></app-ds-badge>
            </button>
        </ng-container>
        <ng-template #staticPill>
            <app-ds-badge size="sm" [theme]="pill.theme" [icon]="pill.icon" [label]="pill.label"></app-ds-badge>
        </ng-template>

        <ng-container *ngIf="state?.verifiedText">
            <ds-text size="xs" weight="regular" theme="secondary" [text]="state?.verifiedText"></ds-text>
        </ng-container>
    </div>
</ng-container>
